function validateImage(image) {
    if (image.type != 'image/png' && image.type != 'image/jpeg') {
        return false;
    }
    return true;
}

export {validateImage};